var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vertical carousel slide w-100 pl-4",
      attrs: {
        id: "carouselDesktop",
        "data-bs-ride": "carousel",
        "data-bs-interval": "10000"
      }
    },
    [
      _c(
        "div",
        { staticClass: "carousel-inner" },
        _vm._l(_vm.banners, function(banner, index) {
          return _c(
            "div",
            { class: ["carousel-item h-window", { active: index === 0 }] },
            [
              _c("div", { staticClass: "d-flex align-items-stretch h-100" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-6 h-100 d-flex flex-column align-items-start"
                  },
                  [
                    banner.arrowTop
                      ? _c("img", {
                          staticClass: "flex-1 w-auto",
                          attrs: { src: banner.arrowTop }
                        })
                      : _c("div", { staticClass: "flex-1" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "my-3 w-100 align-self-center" }, [
                      _c("h2", { staticClass: "info-title" }, [
                        _vm._v(_vm._s(banner.title))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-button" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(banner.button) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "info-detail" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(banner.desc) +
                            "\n            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    banner.arrowBottom
                      ? _c("img", {
                          staticClass: "flex-1 w-auto",
                          attrs: { src: _vm.banners[0].arrowBottom }
                        })
                      : _c("div", { staticClass: "flex-1" })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 align-self-center" }, [
                  _c("img", {
                    staticClass: "mw-100 mh-100",
                    attrs: { src: banner.bnr }
                  })
                ])
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "position-absolute d-flex justify-content-center align-items-center",
          staticStyle: {
            left: "25px",
            top: "50vh",
            transform: "translate(-50%) rotate(90deg)"
          }
        },
        [
          _c(
            "a",
            {
              attrs: {
                href: "#carouselDesktop",
                role: "button",
                "data-bs-slide": "prev"
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "28",
                    height: "28",
                    viewBox: "0 0 28 28",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M15.9425 19L17 17.9425L13.565 14.5L17 11.0575L15.9425 10L11.4425 14.5L15.9425 19Z",
                      fill: "#505050"
                    }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "#carouselDesktop",
                role: "button",
                "data-bs-slide": "next"
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "28",
                    height: "28",
                    viewBox: "0 0 28 28",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M12.0575 9L11 10.0575L14.435 13.5L11 16.9425L12.0575 18L16.5575 13.5L12.0575 9Z",
                      fill: "#505050"
                    }
                  })
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ol",
      {
        staticClass:
          "carousel-indicators signup-carousel position-relative my-0 mx-2"
      },
      [
        _c("li", {
          staticClass: "active",
          attrs: {
            "data-bs-target": "#carouselDesktop",
            "data-bs-slide-to": "0"
          }
        }),
        _vm._v(" "),
        _c("li", {
          attrs: {
            "data-bs-target": "#carouselDesktop",
            "data-bs-slide-to": "1"
          }
        }),
        _vm._v(" "),
        _c("li", {
          attrs: {
            "data-bs-target": "#carouselDesktop",
            "data-bs-slide-to": "2"
          }
        }),
        _vm._v(" "),
        _c("li", {
          attrs: {
            "data-bs-target": "#carouselDesktop",
            "data-bs-slide-to": "3"
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }